import { Component, inject, signal } from '@angular/core';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { QuestionCard } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-carousel-logic-form',
  templateUrl: './carousel-logic-form.component.html',
  styleUrls: ['./carousel-logic-form.component.scss']
})
export class CarouselLogicFormComponent {
  faClose = faClose;
  surveyConditionalsService = inject(SurveyConditionalsService);

  selectedCard$ = signal<QuestionCard>(null);

  onClearCardSelected(): void {
    this.surveyConditionalsService.conditionForm$().get('cardId').reset();
    this.surveyConditionalsService.conditionForm$().get('valueToMatch').reset();
    this.surveyConditionalsService.conditionForm$().get('operator').reset();
  }

  onUpdateSelectedCardStimulus(): void {
    this.selectedCard$.set(
      this.surveyConditionalsService.questionSelected$().cards.find((c) => this.surveyConditionalsService.conditionForm$().get('cardId').value === c.id)
    );
  }
}
